export enum PageTemplate {
  CATEGORY = 'CategoryPageTemplate',
  PRODUCT = 'ProductDetailsPageTemplate',
  PRODUCTLIST = 'ProductListPageTemplate',
  ERRORPAGE = 'ErrorPageTemplate',
  CHECKOUT = 'MultiStepCheckoutSummaryPageTemplate',
  CART = 'CartPageTemplate',
  ORDERCONFIRMATION = 'OrderConfirmationPageTemplate',
  STOREFINDER = 'StoreFinderPageTemplate',
  CHECKOUTACCOUNT = 'CheckoutAccountPageTemplate',
  SEARCHRESULTSLIST = 'SearchResultsListPageTemplate',
}
